import { Link } from "react-router-dom";
import { mockInfluencers } from "@/mocks/influencers";

const platformIcon: Record<string, string> = {
  tiktok: "ri-tiktok-line",
  youtube: "ri-youtube-line",
  twitter: "ri-twitter-x-line",
};

export default function InfluencerBanner() {
  return (
    <section
      className="py-16 px-6 md:px-12 relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #B8860B 0%, #DAA520 25%, #FFD700 50%, #DAA520 75%, #B8860B 100%)" }}
    >
      {/* Shimmer overlay */}
      <div
        className="absolute inset-0 opacity-20"
        style={{ backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,0.15) 10px, rgba(255,255,255,0.15) 20px)" }}
      />
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/8b3f8e7ce04b2c23ea8474ed259f6624.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <span
            className="inline-block text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-4"
            style={{ background: "rgba(61,32,0,0.2)", color: "#3D2000" }}
          >
            Influencer Hub
          </span>
          <h2 className="text-4xl font-extrabold mb-4" style={{ color: "#3D2000" }}>
            Amplify Your Influence, <span style={{ color: "#5C3D00" }}>Earn More</span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: "#6B4500" }}>
            TikTok stars, YouTube creators, Twitter influencers — partner with verified factories and earn up to 15% commission on every sale.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
          {[
            { value: "$2.4M+", label: "Paid to Influencers", icon: "ri-money-dollar-circle-line" },
            { value: "180K+", label: "Active Influencers", icon: "ri-user-star-line" },
            { value: "15%", label: "Max Commission", icon: "ri-percent-line" },
            { value: "50K+", label: "Products Available", icon: "ri-store-2-line" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div
                className="w-12 h-12 flex items-center justify-center rounded-full text-xl mx-auto mb-3"
                style={{ background: "rgba(61,32,0,0.15)", color: "#3D2000" }}
              >
                <i className={stat.icon} />
              </div>
              <div className="text-3xl font-bold mb-1" style={{ color: "#3D2000" }}>{stat.value}</div>
              <div className="text-sm" style={{ color: "#6B4500" }}>{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Top Influencers */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-10">
          {mockInfluencers.map((inf) => (
            <div
              key={inf.id}
              className="rounded-xl p-4 text-center hover:scale-105 transition-transform cursor-pointer border"
              style={{ background: "rgba(255,255,255,0.28)", borderColor: "rgba(255,255,255,0.5)" }}
            >
              <div className="relative w-14 h-14 mx-auto mb-3">
                <img
                  src={inf.avatar}
                  alt={inf.name}
                  className="w-14 h-14 rounded-full object-cover object-top"
                />
                {inf.verified && (
                  <div
                    className="absolute -bottom-1 -right-1 w-5 h-5 flex items-center justify-center rounded-full"
                    style={{ background: "#3D2000" }}
                  >
                    <i className="ri-check-line text-xs" style={{ color: "#FFD700" }} />
                  </div>
                )}
              </div>
              <div className="text-xs font-semibold truncate mb-1" style={{ color: "#3D2000" }}>{inf.name}</div>
              <div className="flex items-center justify-center gap-1 text-xs mb-1" style={{ color: "#6B4500" }}>
                <i className={platformIcon[inf.platform]} />
                <span>{inf.followers}</span>
              </div>
              <div className="text-xs font-bold" style={{ color: "#5C3D00" }}>{inf.commission} comm.</div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/influencer"
            className="inline-flex items-center gap-2 px-8 py-4 font-bold rounded-full transition-all hover:scale-105 cursor-pointer text-base whitespace-nowrap"
            style={{ background: "#3D2000", color: "#FFD700" }}
          >
            <i className="ri-star-line" />
            Become an Influencer Partner
          </Link>
        </div>
      </div>
    </section>
  );
}
